import React, { useEffect } from "react";
import { applyTheme } from "@/lib/themes";
import { Navigate, useNavigate } from "react-router-dom";
import { ClipboardCheck, LogOut, ArrowLeft, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import EvaluacionesPortal from "@/components/app/EvaluacionesPortal";

export default function EvaluacionesStandalone() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (user) applyTheme(user.theme_palette, user.theme_btn, { title: user.theme_title_color, body: user.theme_text_color, btn: user.theme_btn_text_color }, user.theme_logo_colors, user.theme_panel_color, user.theme_custom_color);
  }, [user]);
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-navy" /></div>;
  if (!user) return <Navigate to="/" replace />;
  const home = user.role === "docente" ? "/docente" : user.staff_kind === "coordinacion" ? "/direccion" : "/dashboard";
  return (
    <div className="min-h-screen bg-[#f6f5fb]" data-testid="eval-standalone">
      <header className="sticky top-0 z-30 bg-gradient-to-r from-navy-ink via-navy-ink to-navy-ink text-white shadow-lg">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center gap-3">
          <span className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center"><ClipboardCheck className="w-5 h-5" /></span>
          <div className="flex-1 min-w-0">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/80 truncate">ZAVIA · {user.school_name || ""}</div>
            <div className="font-display font-bold text-lg leading-tight">Portal de Evaluaciones</div>
          </div>
          <span className="hidden sm:block text-sm text-white/80 truncate max-w-[200px]">{user.name}</span>
          <button onClick={() => nav(home)} className="hidden sm:inline-flex items-center gap-1 text-xs bg-white/10 hover:bg-white/20 px-3 py-2 rounded-lg" data-testid="eval-go-home"><ArrowLeft className="w-3.5 h-3.5" /> Mi portal</button>
          <button onClick={logout} className="inline-flex items-center gap-1 text-xs bg-white/10 hover:bg-white/20 px-3 py-2 rounded-lg" data-testid="eval-logout"><LogOut className="w-3.5 h-3.5" /> Salir</button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6 sm:py-8"><EvaluacionesPortal /></main>
    </div>
  );
}
